import React from 'react';
import { ButtonClean, Icon, Tooltip, useCopyToClipboard } from '@fourthwall/components';
import { DuplicateIcon, TickIcon } from '@fourthwall/icons';
import * as S from './HMACDisplay.styled';
export const HMACDisplay = ({ hmac }) => {
    const { isCopied, copyToClipboard } = useCopyToClipboard();
    if (!hmac)
        return null;
    const truncatedHmac = hmac.length > 50 ? `${hmac.substring(0, 50)}...` : hmac;
    return (React.createElement(S.Container, null,
        React.createElement(S.HMACContainer, null,
            React.createElement("div", null, truncatedHmac),
            React.createElement("div", null, isCopied ? (React.createElement(Tooltip, { reference: React.createElement(Icon, { component: TickIcon, height: 12 }) }, "Copied!")) : (React.createElement(Tooltip, { reference: React.createElement(ButtonClean, { label: "", icon: DuplicateIcon, onClick: () => copyToClipboard(hmac) }) }, "Copy"))))));
};
